// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  margin-bottom: 0;
  padding-bottom: 0;
  color: #111111;
}

.name {
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
}

.infoTable {
  width: 100%;
}

.analysisTabs {
  margin-top: -2px;
}

.analysisTabs h2 {
  font-size: 1.4rem;
  padding-top: 15px;
}

#individusListing, #jobsListing {
  margin: 10px 0;
  width: 100%;
}

#individusListing th:first-child {
  width: 60%;
  text-align: left;
}

#individusListing th, #individusListing td {
  text-align: center;
  padding: 4px 0;
}

#individusListing td:first-child {
  text-align: left;
}

.jobsSection {
  min-height: 160px;
}

#jobsListing td {
  padding: 4px 0;
}

.noData {
  padding-top: 15px;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
}

.addingPanel h2 {
  position: absolute;
}

.addingPanel .mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 14px;
}

.addingPanel .mat-icon-button {
  position: absolute;
  right: 17px;
  z-index: 100;
}

.graphs {
  margin: 5px 0;
}

.graphsPad {
  padding: 5px 20px;
}

.trait, .prb, .profiler {
  border: 1px solid #aaaaaa;
  background-color: #EDF2F5;
}

.nameGb, .jobTitle {
  max-width: 70%;
}

.truncate {
  margin: 0;
  padding: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::ng-deep .analysisTabs .mat-tab-header {
  border-bottom: 1px solid #bcbcbc;
}

::ng-deep .analysisTabs .mat-tab-label {
  font-size: 1.4rem;
  padding: 0 24px;
}

::ng-deep .analysisTabs .mat-tab-body {
  min-height: 40px;
  max-height: 200px;
}

::ng-deep .justifyRight .mat-grid-tile .mat-figure {
  justify-content: flex-end;
}

::ng-deep .noData .mat-icon-button {
  line-height: 7px;
  margin: 0 17px;
}

::ng-deep .nameGb.mat-grid-tile .mat-figure, ::ng-deep .jobTitle.mat-grid-tile .mat-figure {
  justify-content: flex-start;
}

::ng-deep .typeGb.mat-grid-tile .mat-figure, ::ng-deep .itemDate.mat-grid-tile .mat-figure {
  justify-content: flex-end;
}

::ng-deep .addingPanel .mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]), ::ng-deep .addingPanel .mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]), ::ng-deep .addingPanel .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: transparent;
}

::ng-deep .addingPanel .mat-expansion-panel-header {
  width: 0;
}

::ng-deep .addingPanel .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}

::ng-deep .addingPanel .mat-expansion-panel-header {
  padding: 0;
}

::ng-deep .addingPanel .mat-expansion-panel-header-description,
::ng-deep .addingPanel .mat-expansion-panel-header-title {
  margin: 0;
  font-size: 1.2rem;
}

::ng-deep .addingPanel .mat-expansion-indicator,
::ng-deep .addingPanel .mat-expansion-panel-header.mat-expanded .mat-icon-button,
::ng-deep .addingPanel .mat-expansion-panel-header.mat-expanded .mat-icon {
  display: none;
}

::ng-deep .addingPanel .mat-content {
  max-width: 107px;
}

::ng-deep .addingPanel .mat-expansion-panel-body {
  border: 1px #bcbcbc solid;
  padding: 0 15px 10px;
  font-size: 1.3rem;
}

::ng-deep .addingPanel .mat-expansion-panel-body h3 {
  font-size: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/graphboards/components/mobile/mobile-graphboards-report/mobile-graphboards-report.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,WAAA;AACJ;;AAEA;EACI,UAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAMQ;EACI,uBAAA;AAHZ;;AAQA;EACI,QAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,UAAA;AALJ;;AAQA;;EAEI,SAAA;EACA,iBAAA;AALJ;;AAQA;;;EAGI,aAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,yBAAA;EACA,oBAAA;EACA,iBAAA;AALJ;;AAQA;EACI,iBAAA;AALJ","sourcesContent":["h2 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    color: #111111;\n}\n\n.name {\n    font-size: 1.4rem;\n    margin: 0;\n    padding: 0;\n}\n\n.infoTable {\n    width: 100%;\n}\n\n.analysisTabs {\n    margin-top: -2px;\n}\n\n.analysisTabs h2 {\n    font-size: 1.4rem;\n    padding-top: 15px;\n}\n\n#individusListing, #jobsListing {\n    margin: 10px 0;\n    width: 100%;\n}\n\n#individusListing th:first-child {\n    width: 60%;\n    text-align: left;\n}\n\n#individusListing th, #individusListing td  {\n    text-align: center;\n    padding: 4px 0;\n}\n\n#individusListing td:first-child {\n    text-align: left;\n}\n\n.jobsSection {\n    min-height: 160px;\n}\n\n#jobsListing td {\n    padding: 4px 0;\n}\n\n.noData {\n    padding-top: 15px;\n    text-align: center;\n    font-weight: bold;\n    font-size: 1.5rem;\n}\n\n.addingPanel h2 {\n    position: absolute;\n}\n\n.addingPanel .mat-icon {\n    font-size: 17px;\n    width: 17px;\n    height: 17px;\n    line-height: 14px;\n}\n\n.addingPanel .mat-icon-button {\n    position: absolute;\n    right: 17px;\n    z-index: 100;\n}\n\n.graphs {\n    margin: 5px 0;\n}\n\n.graphsPad {\n    padding: 5px 20px;\n}\n\n.trait, .prb, .profiler {\n    border: 1px solid #aaaaaa;\n    background-color: #EDF2F5;\n}\n\n.nameGb, .jobTitle {\n    max-width: 70%;\n}\n\n.truncate {\n    margin: 0;\n    padding: 1px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n::ng-deep .analysisTabs .mat-tab-header {\n    border-bottom: 1px solid #bcbcbc;\n}\n\n::ng-deep .analysisTabs .mat-tab-label {\n    font-size: 1.4rem;\n    padding: 0 24px;\n}\n\n::ng-deep .analysisTabs .mat-tab-body {\n    min-height: 40px;\n    max-height: 200px;\n}\n\n::ng-deep .justifyRight .mat-grid-tile .mat-figure {\n    justify-content: flex-end;\n}\n\n::ng-deep .noData .mat-icon-button {\n    line-height: 7px;\n    margin: 0 17px;\n}\n\n::ng-deep .nameGb.mat-grid-tile .mat-figure, ::ng-deep .jobTitle.mat-grid-tile .mat-figure {\n    justify-content: flex-start;\n}\n\n::ng-deep .typeGb.mat-grid-tile .mat-figure, ::ng-deep .itemDate.mat-grid-tile .mat-figure {\n    justify-content: flex-end;\n}\n\n::ng-deep .addingPanel .mat-expansion-panel {\n    & .mat-expansion-panel-header.cdk-keyboard-focused,\n    & .mat-expansion-panel-header.cdk-program-focused,\n    &:not(.mat-expanded) .mat-expansion-panel-header:hover {\n        &:not([aria-disabled='true']) {\n            background: transparent;\n        }\n    }\n}\n\n::ng-deep .addingPanel .mat-expansion-panel-header {\n    width: 0;\n}\n\n::ng-deep .addingPanel .mat-expansion-panel:not([class*=mat-elevation-z]) {\n    box-shadow: none;\n}\n\n::ng-deep .addingPanel .mat-expansion-panel-header {\n    padding: 0;\n}\n\n::ng-deep .addingPanel .mat-expansion-panel-header-description,\n::ng-deep .addingPanel .mat-expansion-panel-header-title {\n    margin: 0;\n    font-size: 1.2rem;\n}\n\n::ng-deep .addingPanel .mat-expansion-indicator,\n::ng-deep .addingPanel .mat-expansion-panel-header.mat-expanded .mat-icon-button,\n::ng-deep .addingPanel .mat-expansion-panel-header.mat-expanded .mat-icon {\n    display: none;\n}\n\n::ng-deep .addingPanel .mat-content {\n    max-width: 107px;\n}\n\n::ng-deep .addingPanel .mat-expansion-panel-body {\n    border: 1px #bcbcbc solid;\n    padding: 0 15px 10px;\n    font-size: 1.3rem;\n}\n\n::ng-deep .addingPanel .mat-expansion-panel-body h3 {\n    font-size: 1.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
